var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._g(_vm._b({staticClass:"ozi-text-area",attrs:{"dense":"","filled":"","hide-details":"auto"}},'v-textarea',_vm.attrs,false),_vm.listeners))}
var staticRenderFns = []

export { render, staticRenderFns }